class ResqueJobWithHandleableErrors extends ResqueJob

  constructor: (options) ->
    @url = options.url
    @data = options.data
    @success = options.success
    @error = options.error
    @handle_error = options.handle_error
    @confirm_export = options.confirm_export


  start: ->
    $.ajax
      type: 'POST',
      url: @url,
      data: @data,
      global: false,
      success: (successResponse) =>
        if successResponse.success == false
          @handle_error(successResponse)
          return
        @confirm_export(successResponse)
        @job_id = successResponse.job_id
        @inform()
        setTimeout @check(4000), 2000
      error: =>
        @error()
window.ResqueJobWithHandleableErrors = ResqueJobWithHandleableErrors
